document.addEventListener('DOMContentLoaded', function() {

  // User is not logged in, show the tooltip after 2 seconds
  setTimeout(function() {
    var tooltips = document.getElementsByClassName('header-tooltip__content');
    
    // Loop through both tooltips
    Array.from(tooltips).forEach(function(tooltip) {
      if (tooltip) {
        tooltip.classList.add('fade-in');

        setTimeout(function() {
          tooltip.classList.remove('fade-in');
          tooltip.classList.add('fade-out');
        }, 8000); 
      }
    });
  }, 2000);
});
